module.exports = __webpack_public_path__ + "img/logoFacebook.1c044058.png";